import React, { useContext, useEffect, useRef } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../User/UserProvider';
import { feilInfo, sesjonsLogg } from '../../User/sesjonsLogg';

const LandingPage = (): JSX.Element => {
  const auth = useAuth();
  const history = useHistory();
  const { login } = useContext(UserContext);
  const harTriggetLogin = useRef(false);

  // Ikke gjør automatisk signinRedirect hvis OneLogin nettopp returnerte en
  // feil eller vi står midt i en pågående callback (auth-params i URL-en).
  // Uten dette havner vi i loop mellom /login og /access_denied når
  // OneLogin svarer med error=access_denied.
  const authParamsIUrl = hasAuthParams();
  const authFeilet = !!auth.error;
  const kanTriggeLogin =
    !auth.isLoading &&
    !auth.isAuthenticated &&
    !authFeilet &&
    !authParamsIUrl &&
    !auth.activeNavigator;

  useEffect(() => {
    if (auth.isLoading) return;
    sesjonsLogg('loginside', {
      isAuthenticated: auth.isAuthenticated,
      authParamsIUrl,
      authFeilet,
      activeNavigator: auth.activeNavigator,
      kanTriggeLogin,
      harAlleredeTrigget: harTriggetLogin.current,
      ...(auth.error ? feilInfo(auth.error) : {}),
    });
    if (auth.isAuthenticated) {
      history.push('/');
      return;
    }
    if (kanTriggeLogin && !harTriggetLogin.current) {
      harTriggetLogin.current = true;
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoading, auth.isAuthenticated, kanTriggeLogin, history, login]);

  if (authFeilet) {
    return (
      <div style={{ maxWidth: '480px', margin: '50px auto' }}>
        <h2>Innlogging feilet</h2>
        <p>{auth.error?.message ?? 'Ukjent feil under innlogging.'}</p>
        <button
          type="button"
          className="kontrollpanel-btn kontrollpanel-btn-innmelding btn btn-primary"
          onClick={() => {
            harTriggetLogin.current = false;
            login();
          }}
        >
          Prøv innlogging på nytt
        </button>
      </div>
    );
  }

  if (auth.isLoading || !auth.isAuthenticated) {
    return <div>Vennligst vent...</div>;
  }

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto' }}>
      <div>
        <button
          type="button"
          className="kontrollpanel-btn kontrollpanel-btn-innmelding hide-on-mobile btn btn-primary"
          onClick={() => login()}
        >
          Logg inn
        </button>
      </div>
    </div>
  );
};

export default LandingPage;

// class LoginPage extends Component {

//   render() {
//     return (
//       <div style={{ maxWidth: '400px', margin: '50px auto' }}>
//         <div>Hei</div>
//         {/* <LoginForm login={this.handleLogin} /> */}
//       </div>
//     );
//   }
// }
